import { DEFAULT_SUBDOMAIN } from '../../../constants/default';
import { IConfig } from '../../../types/config';

const initialState: IConfig = {
  frontContentUrl: '',
  backContentUrl: '',
  subdomain: DEFAULT_SUBDOMAIN,
  abGroup: 100,
  isDomrfEnabled: false,
  salesLeaderInfo: null,
};

export const configReducer = (state = initialState) => {
  return state;
};
